import { HttpTypes } from "@medusajs/types"
import Image from "next/image"
import { colorMap } from "../colorMap"

type ImageGalleryProps = {
  images: HttpTypes.StoreProductImage[]
  options: Record<string, string | undefined>
}

const ImageGallery = ({ images, options }: ImageGalleryProps) => {
  const imagesWithBaseNames = images.map((image) => {
    const baseName =
      decodeURIComponent(image.url)
        .replaceAll(/\d{13}\-/g, "")
        .split("/")
        .pop()
        ?.split(".")[0] || ""
    console.log(baseName)

    const [optionName, optionValue] = baseName.split("_")
    // split on first number occurence

    console.log({ optionName, optionValue })

    return {
      ...image,
      baseName,
      optionName,
      optionValue,
      selectedOption: options[optionName],
      // index,
    }
  })

  const baseImages = imagesWithBaseNames.filter(
    (image) => image.optionName === "Base"
  )

  const selectedBaseImages = baseImages.filter((image) => {
    const selectedOption = Object.entries(options).find(
      ([, optionValue]) => {
        return optionValue === image.optionValue
      }
    )
    return selectedOption
  })

  const colorImages = imagesWithBaseNames.filter((image) =>
    image.optionName.startsWith("Color")
  )

  return (
    <div className="relative flex flex-col flex-1 medium:mx-8 gap-y-4 mx-auto">
      <div className="relative aspect-square w-full max-w-[500px] mx-auto">
        {selectedBaseImages.map((image, index) => {
          return (
            <Image
              unoptimized
              key={image.id}
              id={image.id}
              src={image.url}
              fill
              className="overflow-hidden object-contain"
              alt={`Product image ${index + 1}`}
              sizes="(max-width: 576px) 100vw, (max-width: 768px) 80vw, (max-width: 992px) 60vw, 500px"
            />
          )
        })}
      </div>

      {colorImages.map((image) => {
        const colorFromMap =
          colorMap[image.selectedOption!] || image.selectedOption

        return (
          <div
            key={image.id}
            id={image.id}
            className="absolute overflow-hidden inset-0 top-0 left-0 right-0 bottom-0 w-full h-full max-w-[500px] mx-auto"
            style={{
              backgroundColor: colorFromMap,
              objectFit: "cover",
              maskRepeat: "no-repeat",
              maskSize: "contain",
              mixBlendMode: "multiply",
              maskImage: `url('${image.url.replace(" ", "%20")}')`,
            }}
          />
        )
      })}
    </div>
  )
}

export default ImageGallery
